/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize DashboardPatientView View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './dashboardPatientView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsDashboardPatientViewEdit = mapStateToProps;
export const mapDispatchToPropsDashboardPatientViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsDashboardPatientViewEdit,
  mapDispatchToPropsDashboardPatientViewEdit
)(View);
